import { getPortfolioProjects, reorderProjects } from '../firebase/portfolio'
import { logger } from './logger'

/**
 * Migration-Utility für bestehende Projekte.
 * Weist Projekten ohne favoriteOrder oder regularOrder eine initiale Reihenfolge zu,
 * basierend auf ihrem Erstellungsdatum (älteste Projekte erhalten niedrigere Nummern).
 */
export const migrateProjectOrders = async () => {
  try {
    const projects = await getPortfolioProjects()
    
    // Nur Projekte migrieren, die noch keine Order haben
    const favorites = projects
      .filter(p => p.isFavorite)
      .sort((a, b) => (a.createdAt?.getTime() || 0) - (b.createdAt?.getTime() || 0))
    
    const regular = projects
      .filter(p => !p.isFavorite)
      .sort((a, b) => (a.createdAt?.getTime() || 0) - (b.createdAt?.getTime() || 0))

    const updates: { id: string; favoriteOrder?: number; regularOrder?: number }[] = []

    favorites.forEach((p, index) => {
      if (p.id && p.favoriteOrder === undefined) {
        updates.push({ id: p.id, favoriteOrder: index + 1 })
      }
    })

    regular.forEach((p, index) => {
      if (p.id && p.regularOrder === undefined) {
        updates.push({ id: p.id, regularOrder: index + 1 })
      }
    })

    if (updates.length > 0) {
      logger.info(`Migriere ${updates.length} Projekte mit Order-Feldern...`)
      await reorderProjects(updates)
      logger.info('Migration erfolgreich abgeschlossen.')
    }
  } catch (error) {
    logger.error('Fehler bei der Projekt-Migration', error)
  }
}




